import Backbone from 'backbone'
import template from './connector-config.hbs'
import { Connector } from 'canvas'
import select from 'scoreboard-select'
import icon from 'scoreboard/components/icon'
import $ from 'jquery'
const widthIcons = ['small', 'medium', 'thick', 'x-thick']
const dasharrayIcons = ['solid', 'medium', 'small']
const opacityIcons = ['100-percent', '75-percent', '50-percent', '25-percent']
import _ from 'lodash'

var ConnectorConfig = Backbone.View.extend({
	className: 'connector-config',

	events: {
		'change select': 'changeStyle',
		'click .connector-trash': 'deleteConnector'
	},

	initialize: function (opts) {
		Backbone.View.prototype.initialize.apply(this, arguments)
		this.canvas = opts.canvas
	},

	render: function () {
		this.$el.html(template())

		var style = this.model.get('style')

		select(this.el.querySelector('.connector-opacity'), {
			options: Connector.OPACITY.map(function (opacity, i) {
				return {
					selected: style.opacity == opacity,
					value: opacity,
					label: opacity,
					data: {
						icon: opacityIcons[i]
					}
				}
			}),
			render: {
				option: function (d) {
					return icon('connector-opacity-' + d.data.icon)
				},
				item: function (d) {
					return icon('connector-opacity')
				}
			}
		})

		select(this.el.querySelector('.connector-stroke-dasharray'), {
			options: Connector.STROKE_DASHARRAY.map(function (dasharray, i) {
				return {
					selected: style['stroke-dasharray'] == dasharray,
					value: dasharray,
					label: dasharray,
					data: {
						icon: dasharrayIcons[i]
					}
				}
			}),
			render: {
				option: function (d) {
					return icon('connector-stroke-dasharray-' + d.data.icon)
				},
				item: function (d) {
					return icon('connector-stroke-dasharray')
				}
			}
		})

		select(this.el.querySelector('.connector-stroke-width'), {
			options: Connector.STROKE_WIDTH.map(function (width, i) {
				return {
					selected: style['stroke-width'] == width,
					value: width,
					label: width,
					data: {
						icon: widthIcons[i]
					}
				}
			}),
			render: {
				option: function (d) {
					return icon('connector-stroke-width-' + d.data.icon)
				},
				item: function (d) {
					return icon('connector-stroke-width')
				}
			}
		})

		return this
	},

	changeStyle: function (e) {
		this.canvas.history.record()
		var select = $(e.target)
		let type = select.data('style-type')
		let val = select.val()

		this.canvas.connectorsSelection.connectors.forEach(connector => {
			var style = _.clone(connector.get('style'))
			style[type] = val
			connector.set('style', style)
		})
	},

	deleteConnector: function () {
		this.canvas.history.record()
		this.canvas.connectorsSelection.connectors.forEach(connector => {
			connector.collection.remove(connector)
		})

	}

})

export default ConnectorConfig

ConnectorConfig.__filename__ = 'dashboards/widgets/connector-config.js'
